import { useFormController } from '@dreryk/react-common';
import { FormController, StyledFlex } from '@dreryk/react-components';

import { useCurrentPractitionerConfidentialityMode } from '~libs.shared.account';

import { MedicalInformationAttachments } from '../shared/fields/MedicalInformationAttachments';
import { MedicalInformationConfidentialityLevelField } from '../shared/fields/MedicalInformationConfidentialityLevelField/MedicalInformationConfidentialityLevelField';
import { MedicalInformationDescriptionTextarea } from '../shared/fields/MedicalInformationDescriptionTextarea';

import {
   MedicalInformationAddEntryFormBean,
   MedicalInformationAddEntryFormController,
} from './MedicalInformationAddEntryModal.types';

type MedicalInformationAddEntryFormChildrenRenderProps = Pick<
   MedicalInformationAddEntryFormController,
   'handleSubmit' | 'formState'
>;

type MedicalInformationAddEntryFormProps = {
   readonly medicalInformationId: number;
   readonly children: (renderProps: MedicalInformationAddEntryFormChildrenRenderProps) => JSX.Element;
};

export const MedicalInformationAddEntryForm = (props: MedicalInformationAddEntryFormProps): JSX.Element => {
   const defaultConfidentialityLevel = useCurrentPractitionerConfidentialityMode();
   const { register, control, handleSubmit, formState, sync } = useFormController<MedicalInformationAddEntryFormBean>({
      id: props.medicalInformationId,
      description: null,
      confidentialityLevel: defaultConfidentialityLevel,
   });

   return (
      <StyledFlex direction={'column'} gap={'24px'}>
         <FormController controller={register('id', { required: true })} />
         <MedicalInformationDescriptionTextarea register={register} control={control} required />
         <MedicalInformationConfidentialityLevelField register={register} />
         <MedicalInformationAttachments
            controller={register('attachments')}
            medicalInformationId={props.medicalInformationId}
            sync={sync}
         />

         {props.children({ handleSubmit: handleSubmit, formState: formState })}
      </StyledFlex>
   );
};
